import { RootState } from "../types";

export const getInitialIngridientsItems = (state: RootState) => state.initialIngridients.items;